module.exports = __webpack_public_path__ + "img/tarjeta_servicios_asesoramiento_juridico.ab51cb8a.jpg";